module.exports = __webpack_public_path__ + "img/Advantage_icon05.5e13ac66.png";